import React from 'react';
import ParinitaPhoto from '../Parinita.jpeg';

function AboutSection() {
  const credentials = [
    { label: "Experience", value: "8+ Years" },
    { label: "License", value: "CRN9295322" },
    { label: "Works with", value: "Adolescents, Adults, Older Adults" },
    { label: "Languages", value: "English, Hindi, Bengali" },
    { label: "Locations", value: "Online (Telephonic, Video Call)" }
  ];

  return (
    <section id="about" className="bg-white py-24 px-6 md:px-16 lg:px-24 rounded-t-[4rem] md:rounded-t-[5rem] shadow-[0_-20px_50px_-20px_rgba(0,0,0,0.03)] relative z-20">
      <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-16 lg:gap-20">
        
        {/* Photo Section */}
        <div className="lg:w-5/12 w-full max-w-md mx-auto">
          <div className="relative group">
            <div className="absolute inset-0 bg-ocean-teal rounded-[3rem] rotate-3 group-hover:rotate-0 transition-transform duration-700 opacity-10"></div>
            <img 
              src={ParinitaPhoto} 
              alt="Parinita Dutta Roy - Clinical Psychologist" 
              className="relative z-10 w-full aspect-[4/5] object-cover rounded-[3rem] shadow-2xl group-hover:scale-[1.02] transition-transform duration-700 ease-out"
              loading="lazy"
            />
          </div>
        </div>

        {/* Details Section */}
        <div className="lg:w-7/12 space-y-8">
          <div>
            <span className="text-xs font-black uppercase tracking-[0.3em] text-ocean-teal">About Me</span>
            <h2 className="text-4xl md:text-5xl font-serif font-bold text-deep-charcoal leading-tight mt-4 mb-6">
              Dedicated to your <br/><span className="text-ocean-teal italic">Mental Well-being.</span>
            </h2>
            <p className="text-lg text-deep-charcoal/70 leading-relaxed">
              I have been in the Mental Health Industry for 8+ years now. I have dedicatedly served my clients with care, patience, and empathy, which I believe are the most essential skills of a psychologist.
            </p>
          </div>

          <div className="bg-[#FDFBF7] p-8 rounded-[2rem] border border-gray-100 shadow-sm">
            <h3 className="text-sm font-black uppercase tracking-[0.2em] text-deep-charcoal mb-6 border-b border-gray-200 pb-4">Professional Profile</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {credentials.map((item, index) => (
                <div key={index}>
                  <p className="text-[10px] font-black uppercase tracking-widest text-ocean-teal">{item.label}</p>
                  <p className="text-deep-charcoal font-bold mt-1">{item.value}</p>
                </div>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-sm font-black uppercase tracking-[0.2em] text-deep-charcoal mb-4">Qualifications & Certifications</h3>
            <div className="flex flex-wrap gap-2">
              {[
                "Masters in Clinical Psychology", "CCI Certified", "Attachment Style Skills", 
                "Certified CBT Practitioner", "Mindfulness Practitioner", "Life Coach", 
                "Animal Communication", "Grief & Bereavement Mgt."
              ].map((cert) => (
                <span key={cert} className="text-xs font-bold bg-ocean-teal/10 text-ocean-teal px-4 py-2 rounded-full border border-ocean-teal/20">
                  {cert}
                </span>
              ))}
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}

export default AboutSection;